module.exports = __webpack_public_path__ + "resources/img/img_coolfilter6.dbd9d44038cc252d06148167a84090bf.png";